// import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
// import btnAuthority from '@/modules/mdm/btnAuthority.js';
import { importLead, importTemplate } from '@mdm/api/leadManage/leadImport.js';
import configurl from '@/config/user.env';

export const tableConfig = {
    selection: true,
    searchFields: [
        {
            name: '客户',
            value: 'customerName',
            type: 'input',
            isFixed: true,
            span: 3
        },
        {
            name: '分公司',
            value: 'companyName',
            type: 'advance',
            isFixed: true,
            span: 4,
            advanceConfig: [
                { 'prop': 'companyNameCn', 'value': '分公司名称' },
                { 'prop': 'companyCode', 'value': '分公司编码' }
            ],
            tableConfig: [
                { 'prop': 'companyCode', 'value': '分公司编码' },
                { 'prop': 'companyNameCn', 'value': '分公司名称', 'displayName': 'companyNameCn' }
            ],
            prefix: '/api-mdm',
            advanceUrl: `/esCompany/popCompany`,
            cbParams: ['companyCode#companyCode', 'companyNameCn#companyName']
        },
        {
            name: '片区',
            value: 'regionCode',
            type: 'select',
            optionNum: 'APP_COMPANY_AREA',
            isFixed: true,
            span: 4
        },
        {
            name: '来源渠道',
            value: 'leadChanel',
            type: 'select',
            optionNum: 'LCRM_LEAD_CHANEL',
            isFixed: true,
            span: 4
        },
        {
            name: '行业与品类',
            value: 'industryName',
            type: 'input',
            isFixed: true,
            span: 3
        },
        {
            name: '线索推荐理由',
            value: 'recommendationReason',
            type: 'input',
            isFixed: false,
            span: 4
        },
        {
            name: '线索状态',
            value: 'leadStatusList',
            type: 'select',
            optionNum: 'LCRM_LEAD_STATUS',
            isFixed: false,
            multiple: true,
            span: 4
        }
        // {
        //     name: '国家',
        //     value: 'ebcuEbplCountryName',
        //     type: 'input',
        //     isFixed: true,
        //     span: 3
        // }
    ],
    columns: [
        {
            label: '来源系统单据ID',
            prop: 'sourceOrderId',
            minWidth: 120
        },
        {
            label: '客户编码',
            prop: 'customerCode',
            type: 'slot',
            minWidth: 120
        },
        {
            label: '客户名称',
            prop: 'customerName',
            minWidth: 120
        },
        {
            label: '联系人',
            prop: 'contactName',
            minWidth: 120
        },
        {
            label: '电话',
            prop: 'contactPhone',
            type: 'slot',
            minWidth: 120,
            className: 'bigData-btn-contact-phone'
        },
        {
            label: '邮箱',
            prop: 'contactEmail',
            type: 'slot',
            minWidth: 120,
            className: 'bigData-btn-contact-email'
        },
        {
            label: '片区',
            prop: 'region',
            minWidth: 120
        },
        {
            label: '分公司',
            prop: 'companyName',
            minWidth: 120
        },
        {
            label: '省份',
            prop: 'provinceName',
            minWidth: 120
        },
        {
            label: '地级市',
            prop: 'cityName',
            minWidth: 120
        },
        {
            label: '县区',
            prop: 'districtName',
            minWidth: 120
        },
        {
            label: '详细地址',
            prop: 'address',
            minWidth: 120
        },
        {
            label: '线索推荐理由',
            prop: 'recommendationReason',
            minWidth: 120
        },
        {
            label: '行业与品类信息',
            prop: 'industryName',
            minWidth: 120
        },
        {
            label: '业务说明',
            prop: 'businessDescription',
            minWidth: 120
        },
        {
            label: '备注',
            prop: 'remark',
            minWidth: 120
        },
        {
            label: '链接',
            prop: 'leadUrl',
            minWidth: 120
        },
        {
            label: '来源系统',
            prop: 'sourceSystem',
            minWidth: 120
        },
        {
            label: '来源渠道',
            prop: 'leadChanel',
            type: 'select',
            optionsKey: 'LCRM_LEAD_CHANEL',
            minWidth: 120
        },
        {
            label: '单据所有人',
            prop: 'orderOwnerName',
            minWidth: 120
        },
        {
            label: '单据所在部门',
            prop: 'deptName',
            minWidth: 120
        },
        {
            label: '公海池/私池',
            prop: 'poolType',
            type: 'select',
            optionsKey: 'LCRM_LEAD_POOL_TYPE',
            minWidth: 120
        },
        {
            label: '线索公海池匹配',
            prop: 'poolName',
            minWidth: 120
        },
        {
            label: '线索负责人匹配',
            prop: 'leadOwnerName',
            minWidth: 120
        },
        {
            label: '生成线索时间',
            prop: 'pushTime',
            minWidth: 120
        },
        {
            label: '线索状态',
            prop: 'leadStatus',
            minWidth: 120,
            type: 'select',
            optionsKey: 'LCRM_LEAD_STATUS'
        },
        {
            label: '创建人',
            prop: 'createUserName',
            minWidth: 100
        },
        {
            label: '创建时间',
            prop: 'createTime',
            minWidth: 160
        },
        {
            label: '修改人',
            prop: 'updateUserName',
            minWidth: 100
        },
        {
            label: '修改时间',
            prop: 'updateTime',
            minWidth: 160
        }
    ],
    actions: { // 表格操作列的配置
        fixedWidth: 120, // fixedWidth（可选） 设置操作列的固定宽度，不加该参数默认是按钮list长度*50px
        list: [
            {
                label: '生成线索',
                event: 'generate',
                displayRule: (row) => {
                    return [1, 4].includes(+row.leadStatus);
                }
            },
            {
                label: '废弃',
                event: 'abandoned',
                displayRule: (row) => {
                    return [1, 4].includes(+row.leadStatus);
                }
            }
        ]
    },
    importConfig: {
        action: configurl.apiUrl + 'api-lcrm/contractEnclosureInfo/upload',
        downloadApi: importTemplate,
        importApi: importLead,
        downParams: {
            fileName: '线索导入模板.xlsx'
        },
        multiple: false,
        accept: '.xlsx,.xls',
        limtSizeKey: 'leadImport',
        downBtn: true,
        showFileList: false,
        fileType: '只能上传Excel文件',
        manualUpload: true
    }
};
